import { Box, Typography } from "@mui/material";
import { LIMITED_WIDTH } from "app/styles";
import { Newsletter } from "components/Newsletter";
import lotusIcon from "images/icons/lotus-grey-2.svg";
import { SuccessPageLayout } from "layouts/SuccessPageLayout";
import { Image } from "mui-image";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    dark: {
        backgroundImage: "none",
        paddingTop: theme.spacing(8),
        backgroundColor: theme.palette.grey800,
        color: theme.palette.coral100,
        marginTop: 0,

        "& $link": {
            color: theme.palette.coral100,

            "&:hover": {
                color: theme.palette.aqua700,
            },
        },
    },
    container: { minHeight: "unset" },
}));
export const VisitorDonateSuccess = () => {
    const classes = useStyles();

    return (
        <SuccessPageLayout centered={true}>
            <Box sx={{ width: "25%", maxWidth: 100, display: "inline-block", mb: 4 }}>
                <Image src={lotusIcon} />
            </Box>
            <Typography variant="body1" sx={{ maxWidth: LIMITED_WIDTH }}>
                Thank you very much. Your contribution gives fuel to the movement and helps shapes
                the energy we all surround ourselves with.
            </Typography>
            <Typography variant="body1" sx={{ maxWidth: LIMITED_WIDTH }}>
                Stay in touch to see what your contribution is going towards
            </Typography>
            <div className={classes.dark}>
                {/* NOTE: currently, the newsletter breaks when not in dark mode, so fix that first if you want to use this on a light background */}
                <Newsletter dark={true} />
            </div>
        </SuccessPageLayout>
    );
};
